/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import icons from '../../../../data/icons';

const OfferDetailsTexts = ({ item }) => (
    <div className={ cx('container-offer-details-texts') }>
        <div className="layout">
            <div className="offer-details-texts">
                <span className="offer-details-text" dangerouslySetInnerHTML={ { __html: item.translations.description } }/>
                <span
                  className="offer-details-texts-icon"
                  dangerouslySetInnerHTML={ { __html: icons.offer.magnifier } }
                />
            </div>
        </div>
    </div>
);

OfferDetailsTexts.propTypes = {
    item: PropTypes.shape().isRequired
};

export default OfferDetailsTexts;



// WEBPACK FOOTER //
// ./src/components/content/offer/details/OfferDetailsTexts.jsx